<template>
  <div class="vendor-form">
    <p class="vendor-form-label">
      {{ label }}<span class="text-ast" v-if="isRequired">*</span>
    </p>
    <input-select :options="options" :modelName="modelName" :storeName="storeName" :mutationName="mutationName"
      :disabled="disabled" />
  </div>
</template>
<script>
import InputSelect from './input/input-select.vue'
export default {
  components: { InputSelect },
  props: [
    'options',
    'modelName',
    'label',
    'storeName',
    'mutationName',
    'isRequired',
    'disabled',
  ],
  created() {
  },
}
</script>
